var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _vm.campaign
        ? _c("table", { staticClass: "table" }, [
            _c("tbody", [
              _vm._m(0),
              _c("tr", [
                _c("td"),
                _c("td", [_vm._v("Unreached")]),
                _c("td", [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "d-block" }, [
                      _vm.campaign.team.target_picture_not_reached
                        ? _c("img", {
                            staticClass: "img img-fluid image-preview",
                            attrs: {
                              src: _vm.campaign.team.target_picture_not_reached,
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "file",
                        accept: "image/*",
                        name: "target_picture_not_reached",
                        disabled: _vm.disabled,
                      },
                      on: { change: _vm.upload },
                    }),
                  ]),
                ]),
                _c("td", [_vm._v("Reached")]),
                _c("td", [
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "d-block" }, [
                      _vm.campaign.team.target_picture_reached
                        ? _c("img", {
                            staticClass: "img img-fluid image-preview",
                            attrs: {
                              src: _vm.campaign.team.target_picture_reached,
                            },
                          })
                        : _vm._e(),
                    ]),
                    _c("input", {
                      staticClass: "form-control",
                      attrs: {
                        type: "file",
                        accept: "image/*",
                        name: "target_picture_reached",
                        disabled: _vm.disabled,
                      },
                      on: { change: _vm.upload },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { attrs: { colspan: "5" } }, [
        _vm._v(" Target Icon on progress bar (recommended size 69 x69 px) "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }